import { render, staticRenderFns } from "./NotizModal.vue?vue&type=template&id=7a1ff576&scoped=true"
import script from "./NotizModal.vue?vue&type=script&lang=js"
export * from "./NotizModal.vue?vue&type=script&lang=js"
import style0 from "./NotizModal.vue?vue&type=style&index=0&id=7a1ff576&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1ff576",
  null
  
)

export default component.exports